function iso2ToFlagEmoji(iso2) {
    if (!iso2 || !/^[A-Z]{2}$/.test(iso2)) return "";
    const A = 0x1f1e6; // Regional Indicator Symbol Letter A
    return String.fromCodePoint(
      ...iso2.toUpperCase().split("").map((ch) => A + (ch.charCodeAt(0) - 65))
    );
  }
  
  const VARIOUS_OPTIONS = [
    { name: "Various / Multiple", value: "various", flag: "🌐", iso2: null },
    { name: "Unknown / Ancient", value: "unknown", flag: "🏳️", iso2: null },
  ];
  
  // Keep as long as you want
  const COUNTRY_LIST = [
    { name: "Argentina", iso2: "AR" },
    { name: "Australia", iso2: "AU" },
    { name: "Austria", iso2: "AT" },
    { name: "Belgium", iso2: "BE" },
    { name: "Bolivia", iso2: "BO" },
    { name: "Brazil", iso2: "BR" },
    { name: "Bulgaria", iso2: "BG" },
    { name: "Canada", iso2: "CA" },
    { name: "Chile", iso2: "CL" },
    { name: "China", iso2: "CN" },
    { name: "Colombia", iso2: "CO" },
    { name: "Costa Rica", iso2: "CR" },
    { name: "Croatia", iso2: "HR" },
    { name: "Cuba", iso2: "CU" },
    { name: "Czech Republic", iso2: "CZ" },
    { name: "Denmark", iso2: "DK" },
    { name: "Dominican Republic", iso2: "DO" },
    { name: "Ecuador", iso2: "EC" },
    { name: "Egypt", iso2: "EG" },
    { name: "El Salvador", iso2: "SV" },
    { name: "England", iso2: "GB" }, // treat as UK flag
    { name: "Estonia", iso2: "EE" },
    { name: "Ethiopia", iso2: "ET" },
    { name: "Finland", iso2: "FI" },
    { name: "France", iso2: "FR" },
    { name: "Germany", iso2: "DE" },
    { name: "Greece", iso2: "GR" },
    { name: "Guatemala", iso2: "GT" },
    { name: "Haiti", iso2: "HT" },
    { name: "Hungary", iso2: "HU" },
    { name: "Iceland", iso2: "IS" },
    { name: "India", iso2: "IN" },
    { name: "Indonesia", iso2: "ID" },
    { name: "Iran", iso2: "IR" },
    { name: "Iraq", iso2: "IQ" },
    { name: "Ireland", iso2: "IE" },
    { name: "Israel", iso2: "IL" },
    { name: "Italy", iso2: "IT" },
    { name: "Japan", iso2: "JP" },
    { name: "Jordan", iso2: "JO" },
    { name: "Kenya", iso2: "KE" },
    { name: "Lebanon", iso2: "LB" },
    { name: "Lithuania", iso2: "LT" },
    { name: "Luxembourg", iso2: "LU" },
    { name: "Mexico", iso2: "MX" },
    { name: "Moldova", iso2: "MD" },
    { name: "Netherlands", iso2: "NL" },
    { name: "New Zealand", iso2: "NZ" },
    { name: "Nigeria", iso2: "NG" },
    { name: "Norway", iso2: "NO" },
    { name: "Palestine", iso2: "PS" },
    { name: "Panama", iso2: "PA" },
    { name: "Paraguay", iso2: "PY" },
    { name: "Peru", iso2: "PE" },
    { name: "Philippines", iso2: "PH" },
    { name: "Poland", iso2: "PL" },
    { name: "Portugal", iso2: "PT" },
    { name: "Romania", iso2: "RO" },
    { name: "Russia", iso2: "RU" },
    { name: "Scotland", iso2: "GB" }, // treat as UK flag
    { name: "Serbia", iso2: "RS" },
    { name: "Slovakia", iso2: "SK" },
    { name: "Slovenia", iso2: "SI" },
    { name: "South Africa", iso2: "ZA" },
    { name: "South Korea", iso2: "KR" },
    { name: "Spain", iso2: "ES" },
    { name: "Sri Lanka", iso2: "LK" },
    { name: "Sweden", iso2: "SE" },
    { name: "Switzerland", iso2: "CH" },
    { name: "Syria", iso2: "SY" },
    { name: "Tanzania", iso2: "TZ" },
    { name: "Thailand", iso2: "TH" },
    { name: "Turkey", iso2: "TR" },
    { name: "Uganda", iso2: "UG" },
    { name: "Ukraine", iso2: "UA" },
    { name: "United Kingdom", iso2: "GB" },
    { name: "United States", iso2: "US" },
    { name: "Uruguay", iso2: "UY" },
    { name: "Venezuela", iso2: "VE" },
    { name: "Vietnam", iso2: "VN" },
  ];
  
  const COUNTRY_OPTIONS = COUNTRY_LIST
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((c) => ({
      name: c.name,
      value: c.name.toLowerCase(),
      iso2: c.iso2,
      flag: iso2ToFlagEmoji(c.iso2),
    }));
  
  export const COUNTRY_SELECT_GROUPS = [
    { label: "Various", options: VARIOUS_OPTIONS },
    { label: "Countries", options: COUNTRY_OPTIONS },
  ];
  
  export const COUNTRY_BY_VALUE = new Map(
    COUNTRY_SELECT_GROUPS.flatMap((g) => g.options).map((o) => [o.value, o])
  );
  
  export function countryOption(value) {
    if (!value) return null;
    return COUNTRY_BY_VALUE.get(String(value || "").toLowerCase()) || null;
  }
  
  export function countryLabel(value) {
    const opt = countryOption(value);
    return opt ? opt.name : value;
  }
  
  /**
   * Accepts either:
   * - new format: country = emoji, countryLower = lowercase name
   * - legacy: country = "Italy"
   */
  export function normalizeCountryLower(saint) {
    if (!saint) return "";
    if (saint.countryLower) return String(saint.countryLower).toLowerCase();
    const c = String(saint.country || "").trim();
    // if it's already a lowercased value we used in selects, keep it
    const lc = c.toLowerCase();
    if (COUNTRY_BY_VALUE.has(lc)) return lc;
    // otherwise legacy country name => lower it
    return lc;
  }
  
  export function countryFlagFromSaint(saint) {
    if (!saint) return "";
    // new format stores emoji in `country`
    const c = String(saint.country || "").trim();
    if (c) return c;
  
    // fallback to mapping from countryLower
    const opt = countryOption(saint.countryLower);
    return opt?.flag || "";
  }
  